export default __webpack_public_path__ + "static/media/Nitrox2019.d6956eef.jpeg";